/**
 * 配置的公共参数
 */

export default {
  pubCode: 200,
  companyName: "定远县云创电子科技有限公司",
  /* 给搜索时用加 空状态全部 */
  pubSelect: function(data) {
    let newDa = JSON.parse(JSON.stringify(data));
    newDa.unshift({
      value: "",
      label: "全部",
    });
    return newDa;
  },

  // 通道方向
  trafficDirection: [
    { value: "1", label: "入场" },
    { value: "0", label: "出场" },
  ],
};
